"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
const errors_1 = require("@seneca/errors");
class TutorResourcesServiceClient extends client_library_1.Client {
    constructor(fetch, options) {
        super(fetch, options);
    }
    async queryResources({ query, filters, sort, from, size }) {
        const url = `${this.url}/api/query-resources`;
        const options = {
            method: 'POST',
            body: JSON.stringify({ query, filters, sort, from, size })
        };
        const expectedResponses = [200, 422];
        const response = await this.requestMaker.makeRequest(url, options, expectedResponses);
        if (response.status === 422) {
            const body = response.json;
            throw new errors_1.InvalidArgumentError(body.pointer, body.reason);
        }
        return response.json;
    }
    async fetchResource(id) {
        const url = `${this.url}/api/resources/${id}`;
        const options = {
            method: 'GET'
        };
        const expectedResponses = [200, 400, 404];
        const response = await this.requestMaker.makeRequest(url, options, expectedResponses);
        if (response.status === 400) {
            const body = response.json;
            throw new errors_1.InvalidArgumentError(body.pointer, body.reason);
        }
        if (response.status === 404) {
            return null;
        }
        return response.json;
    }
    async addNewResource({ title, contentUrl, tags, email }) {
        const url = `${this.url}/api/add-resource`;
        const options = {
            method: 'POST',
            body: JSON.stringify({ title, contentUrl, tags, email })
        };
        const expectedResponses = [200, 422];
        const response = await this.requestMaker.makeRequest(url, options, expectedResponses);
        if (response.status === 422) {
            const body = response.json;
            throw new errors_1.InvalidArgumentError(body.pointer, body.reason);
        }
        return response;
    }
}
exports.default = TutorResourcesServiceClient;
//# sourceMappingURL=TutorResourcesServiceClient.js.map